<template>
  <CustomHeader :text="$t('bauDoTesouro.treasure')" :is-popup-close-back-icon="true" @close-popup="navToBack" />
  <div class="bauContainer">
    <van-row>
      <van-col :span="24">
        <div class="banner" style="position: relative; margin-top: -50px">
          <img src="@/assets/themeFour/treasure_banner.png" alt="" />
          <svg class="svgBox" viewBox="0 0 400 100">
            <defs>
              <path id="curve" d="M 20,80 Q 200,20 380,80" fill="none" />

              <linearGradient id="goldGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" style="stop-color: #ffe395; stop-opacity: 1" />
                <stop offset="40%" style="stop-color: #d9a142; stop-opacity: 1" />
                <stop offset="60%" style="stop-color: #b87e2e; stop-opacity: 1" />
                <stop offset="100%" style="stop-color: #f5d482; stop-opacity: 1" />
              </linearGradient>

              <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur in="SourceAlpha" stdDeviation="1" />
                <feOffset dx="1" dy="1" result="offsetblur" />
                <feComponentTransfer>
                  <feFuncA type="linear" slope="0.7" />
                </feComponentTransfer>
                <feMerge>
                  <feMergeNode />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>

            <text style="
                font-size: 22px;
                font-weight: 900;
                font-family: sans-serif;
                filter: url(#shadow);
              " fill="url(#goldGradient)">
              <textPath href="#curve" startOffset="50%" text-anchor="middle">
                {{ $t('treasure.inviteFriends') }}
              </textPath>
            </text>
          </svg>
          <div class="treasure_chest">
            <img src="@/assets/themeFour/treasure_top.png" alt="" />
          </div>
        </div>
      </van-col>
    </van-row>
    <div style="position: relative">
      <div class="contentHeadTitle" style="top: -1%" :style="{ backgroundImage: `url(${treasureBorder})` }">
        <span>{{ $t('treasure.quickShare') }}</span>
      </div>
      <div class="borderContainer">
        <van-row class="secContainer">
          <van-col :span="24">
            <div class="menuLinkCont">
              <div class="menuLinkWrapper">
                <div class="mediaListMain">
                  <div class="mediaListScroll">
                    <div v-for="(item, index) in mediaList" :key="index" class="mediaList" @click="goToShare" style="
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                      ">
                      <img :src="item.icon" style="height: 50.75px; width: 50.75px" class="" alt="" />
                    </div>
                  </div>
                </div>

                <!-- <div class="divider" style=" top: 75%;"></div> -->
                <div class="linkCopy">
                  <span class="menueLinkTxt">{{ $t("common.myLink") }}
                    <span style="color: rgb(13, 176, 174)">{{
                      dataSet.activityConfig?.link
                    }}</span>
                  </span>
                  <img src="@/assets/themeThree/copy-icon.png" alt="" @click="handleCopyValue()" />
                  <img src="@/assets/themeThree/copy-icon.png" alt="" @click="handleCopyValue()" />
                </div>
                <div @click="goToUserDetails" class="go_to_user_button">
                  <van-row style="padding: 0px 10px">
                    <van-col span="15" class="myReport">
                      <p style="">{{ $t("bauDoTesouro.myReports") }}</p>

                      <p style="color: #f5a130">
                        {{ dataSet.activityConfig?.valid_user_count }}
                        <span style="color: #ffff">{{ $t("common.pepole")
                        }}{{ " (" + $t("common.valid") }}</span>
                        {{
                          `
                        ${dataSet.activityConfig?.valid_user_count}`
                        }}
                        <span style="color: #fff">{{
                          $t("common.pepole") + ")"
                        }}</span>
                      </p>
                    </van-col>
                    <van-col span="9" class="details_btn">
                      <p>
                        {{ $t("treasure.details") + " >" }}
                      </p>
                    </van-col>
                  </van-row>
                </div>
              </div>
              <div class="contentHeadTitle" style="bottom: 86.5%; left: -6%;width: 112%;"
                :style="{ backgroundImage: `url(${treasureBorder})` }">
                <span>{{ $t('treasure.refReward') }}</span>
              </div>
              <div class="recordsCard">
                <van-row class="cardRow">
                  <div v-for="(value, index) in zigzagReordered" :key="index" class="cardCol" style="width: 25%;">
                    <div v-if="!value.isNullObject">
                      <RewardBox :peopleCount="value.valid_count" :reward="value.reward" :side="value.side"
                        :down="value.turnDown" :isInCorner="value.isInCorner" :received="value?.received"
                        :isLast="value.isLast" />
                      <div class="arrow" v-if="Number(index) % 4 !== 0">
                        <!-- <span>></span> -->
                      </div>
                    </div>
                  </div>
                </van-row>
              </div>
            </div>
          </van-col>
        </van-row>
        <div class="promo">
          <van-row style="padding: 10px; color: #fff">
            <div class="conditionCheckContainer">
              <van-col :span="24">
                <div style="padding: 0.25rem 0">
                  <span style="color: #fff; font-weight: 700">{{
                    $t("mystery.effectivePromotion")
                  }}</span>
                </div>
              </van-col>
            </div>
          </van-row>

          <van-row style="padding: 0px 10px 10px 10px; color: #ffffff99">
            <div class="conditionCheckContainer">
              <van-col :span="18">
                <span>{{ $t("mystery.requiredDeposit") }}</span>
              </van-col>
              <van-col :span="6" class="arrowImgRight">
                <span style="color: #fc974c; font-weight: 600">{{ "≥"
                }}{{
                    parseFloat(dataSet.activityConfig?.recharge_require)
                      .toFixed(2)
                      .toString()
                      .replace(".", ",")
                  }}</span>
              </van-col>
            </div>
            <div class="conditionCheckContainer">
              <van-col :span="18">
                <span>{{ $t("mystery.requiredTurnove") }}</span>
              </van-col>
              <van-col :span="6" style="display: flex; justify-content: flex-end">
                <span style="color: #fc974c; font-weight: 700">{{ "≥"
                }}{{
                    parseFloat(dataSet.activityConfig?.turnover_require)
                      .toFixed(2)
                      .toString()
                      .replace(".", ",")
                  }}</span>
              </van-col>
            </div>
            <div class="conditionCheckContainer" style="border: none">
              <van-col :span="18">
                <span>{{ $t("report.ipLimit") }}</span>
              </van-col>
              <van-col :span="6" style="display: flex; justify-content: flex-end">
                <span style="color: #fc974c; font-weight: 600">{{
                  dataSet.activityConfig?.ip_limit
                }}</span>
              </van-col>
            </div>
          </van-row>
        </div>
        <div class="rulesCard">
          <div class="bottom_text">
            <div class="bottom_text_sub">
              <img src="@/assets/themeFour/treasure_line_dot.png" style="width: 10%" alt="" />
              <div class="title">{{ $t("tresure.rule") }}</div>
              <img src="@/assets/themeFour/treasure_line_dot.png" style="width: 10%; transform: scaleX(-1)" alt="" />
            </div>
            <div class="line_text" v-for="(item, index) in dataSet.descriptionHtml" :key="index">
              {{ item }}
            </div>
          </div>
        </div>
      </div>
      <img src="@/assets/themeFour/treasure_corner.png"
        style="width: 10%;position: absolute;bottom: -9px;left: 10px;transform: scaleX(-1);">
      <img src="@/assets/themeFour/treasure_corner.png" style="width: 10%;position: absolute;bottom: -9px;right: 10px;">
      <StatusPopup ref="statusRef" :content="$t('common.successfullyCopied')" :isShowSuccess="true" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import RewardBox from "./components/rewardBox.vue";
import {
  toZigZagWithFlags,
  toZigZagWithFlagsAdvance,
} from "@/utils/commonFunction";
import CustomHeader from "../components/common/customHeader.vue";
import { MEDIA_LIST, TreasureData } from "@/view/bauDoTesouro/supportScript";
import { copyValue } from "@/view/bauDoTesouro/supportScript";
import StatusPopup from "@/components/common/statusPopup.vue";
import treasureBorder from "@/assets/themeFour/treasure_border.png";
import treasureHolder from "@/assets/themeFour/treasure_holder.png";
import { useRouter } from "vue-router";
const router = useRouter()
const mediaList = ref(MEDIA_LIST);
const statusRef = ref();
const props = defineProps<{
  dataSet: TreasureData;
}>();

const emits = defineEmits(["goToShare", "goToUserDetails"]);
const zigzagReordered = computed<any>(() => {
  return props.dataSet.activityConfig?.reward_conf;
});

const goToShare = async () => {
  emits("goToShare");
};
const goToUserDetails = async () => {
  emits("goToUserDetails");
};
const handleCopyValue = () => {
  copyValue(props.dataSet.activityConfig?.link, () => {
    statusRef.value?.open();
  });
};
const navToBack = () => {
  localStorage.setItem('footerPopupOpen', '0')
  router.go(-1)

}
</script>
<style scoped>
.bauContainer {
  display: flex;
  justify-content: center;
  flex-direction: column;
  background: #131f42;

  /* padding: 60px 0px 0px 0px; */
}

.banner img {
  width: 100%;
}

.treasureTopImage {
  width: 100%;
  padding-top: 44px;
}

.borderContainer {
  background: #2a2371;
  border: 4px solid #797af1;
  border-top-width: 4px;
  border-top-width: 0;
  box-shadow: 0 0 0 4px #3852eb;
  margin: 0 20px;
  position: relative;
}

.borderContainerTitle img {
  width: 100%;
  position: absolute;
  bottom: 41%;
  left: 0%;
}

.svgBox {
  position: absolute;
  top: 35%;
  left: 12%;
  width: 75%
}

.treasure_chest {
  width: 46%;
  position: absolute;
  bottom: 3%;
  right: 26%
}

.go_to_user_button {
  width: 95%;
  background: rgba(51, 69, 163, 0.4);
  border-radius: 5px;
  margin-top: 10px;
}

.arrowImgRight {
  display: flex;
  justify-content: flex-end
}

.bottom_text_sub {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.details_btn {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #fff;
}

.details_btn p {
  background: rgb(13, 176, 174);
  border-radius: 5px;
  padding: 10px 5px;
}

.secContainer {
  display: flex;
  justify-content: center;
  padding: 0px 0px;
  flex-direction: column;
  margin-top: 0;
}

.contentHeadTitle {
  display: flex;
  justify-content: center;
  color: #fff;
  /* background-image: url(@/assets/themeFour/treasure_border.png); */
  background-size: cover;
  width: 100%;
  height: 50px;
  align-items: center;
  /* line-height: 5px; */
  /* margin-top: -25px; */
  z-index: 1;
  position: absolute;
}

.contentHeadTitle span {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 900;
  color: white;
  text-transform: none;
  -webkit-text-stroke: 0.5px #ff3d00;
  text-shadow: 1px 1px 0px rgba(0, 0, 0, 0.2);
  display: inline-block;
}

.menuLinkWrapper {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /* height: 33vh; */
  /* background-color: #101629; */
  border-radius: 10px;
  gap: 5px;
  margin-top: 25px;
  flex-direction: column;
}

.linkCopy {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 95%;
  /* position: absolute; */
  top: 44%;
  left: 5%;
  background: linear-gradient(90deg,
      rgba(38, 57, 156, 0) 0%,
      #3345a3 50%,
      rgba(38, 57, 156, 0) 100%);
}

.linkCopy img {
  width: 25px;
  margin-right: 10px;
}

.divider {
  height: 0.1px;
  width: 90%;
  background: #1a233e;

  align-items: center;
  position: absolute;
  left: 5%;
}

.myReport {
  color: #ffffffd9;
  font-size: 14px;
  line-height: 5px;
}

.inputFieldOverlay {
  position: absolute;
  top: 15%;
  width: 87%;
}

.mediaListMain {
  /* position: absolute; */
  top: 13%;
  left: 5%;
  z-index: 1;
  width: 90%;
  padding: 5px 0px;
  background: linear-gradient(90deg,
      rgba(38, 57, 156, 0) 0%,
      #3345a3 50%,
      rgba(38, 57, 156, 0) 100%);
}

.mediaListScroll {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.mediaListScroll::-webkit-scrollbar {
  display: none;
}

.menuLinkCont {}

.rewardCard {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.menueLinkTxt {
  color: #fff;
  font-size: 14px;
  display: flex;
  font-weight: 600;
  justify-content: flex-start;
  z-index: 1;
  gap: 5px;
}

.menueLinkBtTxt {
  color: #ffffffd9;
  font-size: 14px;
  position: absolute;
  top: 25%;
  left: 5%;
  display: flex;
  justify-content: flex-start;
  z-index: 1;
}

.active_channel {
  color: #fff;
  background-color: #00bbbb;
  border: 1px solid hsla(0, 0%, 100%, 0.45);
}

.bottom_text {
  padding: 10px;
}

.title {
  color: #fff;
  font-weight: 500;
  font-size: 1.2rem;
  padding: 10px 0;
}

.line_text {
  color: #ffffff99;
  font-size: 14px;
  padding: 5px;
}

.recordsCard {
  /* background: #101629; */
  margin-top: 80px;
  margin-bottom: 5px;
  border-radius: 10px;
  /* max-height: 50vh; */
  overflow: hidden;
}

.conditionCheckContainer {
  padding: 10px 0;
  border-bottom: 1px solid #ffffff1a;
  width: 100%;
  display: flex;
  font-size: 0.875rem;
  font-weight: 500;
}

.promo {
  background: rgba(51, 69, 163, 0.4);
}

.rulesCard {
  /* padding-left: 5%; */
  /* background: #101629; */
  margin-top: 2%;
  border-radius: 10px;
  /* max-height: 50vh; */
  overflow: hidden;
  margin: 5px 15px;
}

.recordsCard::-webkit-scrollbar {
  display: none;
}

.cardRow {
  background-size: contain;
  width: 100%;
}

.cardRow img {
  width: 90%;
}

.cardCol {
  position: relative;
  display: flex;
  margin-bottom: 0%;
}

.arrow {
  color: #fff;
  position: absolute;
  top: 30%;
  right: 105%;
  font-weight: 700;
  z-index: 1;
}

.arrowImgRight img {
  width: 40%;
  position: absolute;
  top: 30%;
  right: 10%;
  rotate: 180deg;
  z-index: 1;
}

.arrowDownImg img {
  width: 40%;
  position: absolute;
  bottom: -45%;
  left: 5%;
  rotate: 90deg;
}

@media (max-width: 450px) {
  .arrowDownImg img {
    bottom: -15%;
    left: 15%;
  }
}
</style>
